import React from 'react';
interface StepNameProps {
  name: string;
  onChange: (name: string) => void;
}
export function StepName({
  name,
  onChange
}: StepNameProps) {
  return <div className="animate-in fade-in slide-in-from-bottom-2 duration-300 space-y-8" data-id="element-2666">
      <div data-id="element-2667">
        <h2 className="text-2xl sm:text-3xl font-bold text-light-1 mb-2" data-id="element-2668">
          Cum o numești?
        </h2>
        <p className="text-sm text-light-3" data-id="element-2669">
          Un nume scurt care te ajută să o recunoști rapid în lista ta.
        </p>
      </div>

      <div data-id="element-2670">
        <label className="block text-xs font-medium text-light-3 uppercase tracking-wider mb-2" data-id="element-2671">
          Nume proprietate <span className="text-lime-1" data-id="element-2672">*</span>
        </label>
        <input type="text" value={name} onChange={e => onChange(e.target.value)} placeholder="ex. Cotroceni · 2 camere" autoFocus className="w-full h-12 px-4 rounded-xl bg-dark-2 border border-dark-4 text-base text-light-1 placeholder:text-light-4 focus:outline-none focus:border-lime-1 transition-colors" data-id="element-2673" />
      </div>
    </div>;
}